import { Size } from '@ps/web-core-enums';
import { ScreenSizeContext } from '@ps/web-shared-components';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { RewardsStateModel } from '@swf/core/types/RewardsLegacy';

import Chest from '../Chest/Chest';
import Nudge from '../Nudge/Nudge';
import PanelDropDownHandler from '../PanelDropDownHandler/PanelDropDownHandler';
import type { Props as ProgressProps } from '../Progress/Progress';
import Progress from '../Progress/Progress';

export interface Props {
  className?: string;
  expanded?: boolean;
  dropDownVisible: boolean;
  rewards: RewardsStateModel;
  onClick(): void;
  onMouseEnter(): void;
  onMouseLeave(): void;
  onTouchStart(): void;
}

const ProgresPanel: React.FC<Props> = ({
  className,
  expanded,
  rewards,
  onClick,
  dropDownVisible,
  onMouseEnter,
  onMouseLeave,
  onTouchStart
}) => {
  const { greaterThan } = useContext(ScreenSizeContext);
  const chestProps = useSelector(select.rewardsLegacy.getChestProps);

  return (
    <PanelDropDownHandler
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
    >
      {(greaterThan(Size.XXSmall) || expanded) && (
        <Progress {...(rewards as ProgressProps)} expanded={expanded} />
      )}
      <Chest {...chestProps} expanded={!!expanded} />
      {!dropDownVisible && !expanded && (rewards.chestsCount || 0) > 0 && (
        <Nudge chestsCount={rewards.chestsCount} />
      )}
    </PanelDropDownHandler>
  );
};

export default ProgresPanel;
